import React, { useEffect, useState } from "react";
import { Row, Col, Typography, Button, Modal, Spin, Card, Result } from "antd";
import Animate from "rc-animate";
import MyProfile from "../../components/MyProfile";
import Post from "./Post";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import * as FirestoreService from "../../firebase";
import PostForm from "./PostForm";
import SignInForm from "../../components/SignInForm";
import { EventsListCard } from "../../components/Events/EventsListCard";

const { Title } = Typography;

const Feed = () => {
  const { innerWidth: width, innerHeight: height } = window;
  const user = useSelector((state) => state.user);
  const profile = useSelector((state) => state.profile);
  const [posts, setPosts] = useState([]);
  const [postAmount, setPostAmount] = useState(5);
  const [loadingFeed, setLoadingFeed] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const history = useHistory();

  const [openModal, setOpenModal] = useState(false);
  const [formReady, setFormReady] = useState(true);

  let data;
  useEffect(() => {
    setLoadingFeed(true);
    const unsubscribe = FirestoreService.streamPosts(postAmount, {
      next: (querySnapshot) => {
        const updatePosts = querySnapshot.docs.map((docSnapshot) => {
          data = docSnapshot.data();
          data.id = docSnapshot.id;
          return data;
        });
        setPosts(updatePosts);
        setLoadingFeed(false);
      },
      error: () => console.log("post-get-fail"),
    });
    return unsubscribe;
  }, [postAmount]);

  let prevAmount;
  const loadMorePosts = () => {
    prevAmount = postAmount;
    if (postAmount > posts.length) {
      setHasMore(false);
    }
    setPostAmount(postAmount + 5);
  };

  return (
    <>
      <Modal
        visible={openModal}
        title="Create Post"
        onCancel={() => setOpenModal(false)}
        footer={[
          profile.odinMember ? (
            <Button
              form="post-form"
              key="submit"
              htmlType="submit"
              block
              disabled={!formReady}
            >
              Create Post
            </Button>
          ) : (
            <></>
          ),
        ]}
      >
        {profile.odinMember ? (
          <PostForm
            onChange={() => setOpenModal(false)}
            formReady={(rdy) => setFormReady(rdy)}
          />
        ) : (
          <Result
            status="warning"
            title="Only subscribed members can create posts."
            extra={
              <Button
                type="primary"
                key="goPro"
                onClick={() => {
                  history.push("/services");
                }}
              >
                Become Odin Member
              </Button>
            }
          />
        )}
      </Modal>

      <Row justify="center">
        <Col xs={24} sm={24} md={20} lg={16} xl={12}>
          <Row justify="space-between">
            <Title level={2}>News Feed</Title>

            <Button type="primary" onClick={() => setOpenModal(true)}>
              Create Post
            </Button>
          </Row>
        </Col>
        <Col xs={24} sm={18} md={12} lg={8} xl={6}></Col>
      </Row>
      <Row gutter={[24, 24]} justify="center">
        <Col xs={24} sm={24} md={20} lg={16} xl={12}>
          {posts.map((postItem, i) => (
            <Post post={postItem} key={i} />
          ))}
          <Row justify="center">
            <Spin size="large" spinning={loadingFeed} delay={100}>
              {hasMore ? (
                <Button
                  type="primary"
                  onClick={() => {
                    loadMorePosts();
                  }}
                >
                  Load More
                </Button>
              ) : (
                <Button type="text" disabled>
                  No more news in feed
                </Button>
              )}
            </Spin>
          </Row>
        </Col>

        {width >= 1000 && (
          <Col xs={24} sm={18} md={12} lg={8} xl={6}>
            <Animate transitionName="fade" transitionAppear>
              {user.jwt ? (
                <>
                  <MyProfile />
                  <EventsListCard />
                </>
              ) : (
                <Card
                  style={{
                    borderRadius: 10,
                    marginBottom: 25,
                    boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)",
                  }}
                >
                  <SignInForm />
                </Card>
              )}
            </Animate>
          </Col>
        )}
      </Row>
    </>
  );
};

export default Feed;
